import { Flex, HStack, Tag, Text, VStack } from '@chakra-ui/react';
import { mdiWeb } from '@mdi/js';
import { PortalIcon } from 'features/common/components/PortalIcon';
import { isInteger } from 'lodash';

interface ISiteCardProps {
  appName: string;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  color?: string;
  'data-testid'?: string;
  ['data-behavior-analytics-id']?: string;
  customerEnvironmentType?: string;
  active?: boolean;
  selected?: boolean;
  events: number;
  destinations?: number;
}

export const SiteCard = ({
  appName,
  onClick,
  onMouseEnter,
  onMouseLeave,
  color = 'neutral',
  'data-testid': dataTestId,
  'data-behavior-analytics-id': dataBehaviorAnalyticsId,
  customerEnvironmentType,
  selected,
  destinations,
}: ISiteCardProps) => {
  // const formatNumber = (value: number) => {
  //   let valueWithSuffix: string | null = null;

  //   if (value || ['string', 'number'].includes(typeof value)) {
  //     const suffixes = ['K', 'M', 'B', 'T'];
  //     let exp = -1;
  //     let val = typeof value === 'string' ? Number.parseFloat(value) : value;

  //     if (!Number.isNaN(val)) {
  //       if (Math.abs(val) >= 1000) {
  //         exp = Math.floor(Math.log(Math.abs(val)) / Math.log(1000));
  //         val = val / Math.pow(1000, exp);
  //       }

  //       valueWithSuffix =
  //         exp < 0 ? `${val}` : `${val.toPrecision(3)}` + suffixes[exp - 1];
  //     }
  //   }

  //   return valueWithSuffix;
  // };

  return (
    <Flex
      background='white'
      borderWidth='1px'
      borderStyle='solid'
      borderColor={selected ? 'purple.500' : 'transparent'}
      boxShadow={selected ? 'lg' : 'base'}
      gap='3'
      p='4'
      w='436px'
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      cursor='pointer'
      _hover={{ backgroundColor: 'gray.100' }}
      data-behavior-analytics-id={dataBehaviorAnalyticsId}
      data-testid={dataTestId}
      data-appname={appName}
      borderRadius='md'
      transitionProperty='common'
      transitionDuration='normal'
      alignItems='center'
    >
      <PortalIcon
        data-testid='site-tile-default-icon'
        boxSize='5'
        m='2'
        path={mdiWeb}
        color={`${color}.600`}
      />

      <VStack
        spacing='0'
        flexGrow='1'
        alignItems='flex-start'
        justifyContent='center'
      >
        <HStack gap='10'>
          <Text
            fontWeight='medium'
            textAlign='left'
            w='full'
            noOfLines={1}
            wordBreak='break-all'
          >
            {appName}
          </Text>
          {customerEnvironmentType && (
            <Tag colorScheme='neutral' size='sm' minW='min-content'>
              {customerEnvironmentType}
            </Tag>
          )}
        </HStack>

        {/* <Text
          textAlign='left'
          color='chakra-subtle-text'
          w='full'
          noOfLines={1}
          wordBreak='break-all'
        >
          Events received: {formatNumber(events)} daily avg
        </Text> */}
      </VStack>

      <VStack spacing='0' flexGrow='1' alignItems='flex-end'>
        {/* <Tag
          colorScheme={active ? 'green' : 'neutral'}
          size='sm'
          fontWeight='semibold'
          textTransform='uppercase'
          visibility='hidden'
        >
          {active ? 'Active' : 'Inactive'}
        </Tag> */}
        {selected && isInteger(destinations) && (
          <Text
            textAlign='right'
            color='chakra-subtle-text'
            w='full'
            noOfLines={1}
            wordBreak='break-all'
          >
            {destinations || 0} destination
            {destinations && destinations > 1 ? 's' : ''}
          </Text>
        )}
      </VStack>
    </Flex>
  );
};
